var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSorobanTokenLogo = function SvgSorobanTokenLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#23024D",
    rx: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.508 11.473c.031-.977.494-1.773 1.242-2.434.244-.216.397-.12.6.032q2.472 1.845 4.948 3.675 3.265 2.433 6.533 4.858c.87.641 1.523 1.414 1.645 2.547.129 1.184-.522 2.227-1.347 2.873-.213.166-.348-.037-.49-.143q-3.797-2.813-7.587-5.636c-1.308-.973-2.627-1.94-3.933-2.92-.925-.686-1.59-1.554-1.611-2.852M17.754 25A6.3 6.3 0 0 1 14 23.712c-1.75-1.344-3.526-2.637-5.29-3.955-.971-.717-.943-1.614.065-2.277 1.217-.809 3.149-.753 4.39.165 2.52 1.866 5.027 3.75 7.538 5.62l.14.105c.726.538.727.538-.104.96a6.55 6.55 0 0 1-2.985.668M14.198 7.003c1.366-.02 2.7.417 3.802 1.245 1.762 1.331 3.548 2.632 5.324 3.952.945.712.893 1.64-.116 2.256a4.09 4.09 0 0 1-4.418-.224q-3.939-2.929-7.884-5.841c-.378-.28-.378-.333.016-.554a6.15 6.15 0 0 1 3.276-.834"
  })));
};
export default SvgSorobanTokenLogo;